export const createReducer = (reducers, def) => (state = def, action) => reducers[action.type] ? reducers[action.type](state, action) : state;

const model = (data, props = {}) => {
	const key = props.key || 'id';

	props.data = data || [];
	props.keys = {};
	if (Array.isArray(props.data)) {
		for (let i in data) {
			props.keys[data[i][key]] = i;
		}
	}
	Object.defineProperty(props,  'length', {
		get: () => props.data.length
	});
	props.filter = fn => props.data.filter(fn);
	props.map = fn => props.data.map(fn);
	props.reverse = () => props.data.reverse();
	props.find = fn => (
		(fn instanceof Function)
			? props.data.find(fn)
			: (fn instanceof Object)
				? props.data.find(m => {
						for (let i in fn) {
							if (m[i] != fn[i])	{
								return false;
							}
						}
						return true;
					})
				: props.get(fn)
	);
	props.first = () => {
		const keys = Object.keys(props.data);
		return keys.length === 0 ? null : props.data[keys[0]] || null;
	},
	props.shift = () => {
		const row = prop.data.shift();
		delete props.keys.keys[row[key]];
		return row;
	};
	props.push = row => {
		if (!Array.isArray(row)) {
			props.keys[row[key]] = props.data.length;
			return props.data.push(row);
		}
		row.forEach(r => {
			props.keys[r[key]] = props.data.length;
			props.data.push(r);
		})
	}
	props.add = row => props.keys[row[key]] = props.data.push(row);
	props.merge = rows => {
		if (!Array.isArray(rows)) {
			rows = [rows]
		}
		for (let row of rows) {
			if (props.keys.hasOwnProperty(row[key])) {
				props.data[props.keys[key]] = row;
			}
			else {
				props.keys[row[key]] = props.data.push(row) - 1;
			}
		}
		return props;
	}
	props.rebuildKeys = () => {
		// reconstruir key indexs
		props.keys = {};
		for (let i in props.data) {
			props.keys[props.data[i][key]] = i;
		}
	}
	props.get = id => props.keys.hasOwnProperty(id) ? props.data[props.keys[id]] : null;
	props.delete = model => {
		const id = model instanceof Object
			? ( props.keys.hasOwnProperty(model[key]) ? model[key] : null)
			: model;

		if (id !== null && props.keys.hasOwnProperty(id)) {
			props.data.splice(props.keys[id], 1);
			props.rebuildKeys();
			return true;
		}
		return false;
	}
	props.unshift = model => {
		props.data.unshift(model);
		props.rebuildKeys();
	}

	return props;
}

export default model;
